import React from 'react';
import { Helmet } from 'react-helmet-async';

const RankingsPage = () => {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://flourishtalents.com/rankings/" />
        <title>Rankings - Flourish Talents</title>
        <meta name="description" content="Discover the top talents and media highlights at Flourish Talents." />
      </Helmet>
      <div className="min-h-screen bg-gray-100 p-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-4">Talent Rankings</h1>
          <p className="mb-6 text-gray-700">
            Explore the most prominent talents featured on Flourish Talents, ranked by performance, popularity, and media coverage.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-4 rounded-2xl shadow-lg">
              <h2 className="text-xl font-semibold">Top Talent 1</h2>
              <p className="text-gray-600">Description of Talent 1 and their recent achievements.</p>
            </div>
            <div className="bg-white p-4 rounded-2xl shadow-lg">
              <h2 className="text-xl font-semibold">Top Talent 2</h2>
              <p className="text-gray-600">Description of Talent 2 and their recent achievements.</p>
            </div>
            <div className="bg-white p-4 rounded-2xl shadow-lg">
              <h2 className="text-xl font-semibold">Top Talent 3</h2>
              <p className="text-gray-600">Description of Talent 3 and their recent achievements.</p>
            </div>
            <div className="bg-white p-4 rounded-2xl shadow-lg">
              <h2 className="text-xl font-semibold">Top Talent 4</h2>
              <p className="text-gray-600">Description of Talent 4 and their recent achievements.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RankingsPage;
